import baseService from '../utils/axios';

export const getLoggedUser = () => baseService.get('/users/me');

export const getIsAccountAdmin = () => baseService.get('/account/is_admin');
